module.exports = __webpack_public_path__ + "static/media/empty_dropdown.b6473dee.svg";